import { render, staticRenderFns } from "./OrderBinding.vue?vue&type=template&id=3ed360e7&"
import script from "./OrderBinding.vue?vue&type=script&lang=js&"
export * from "./OrderBinding.vue?vue&type=script&lang=js&"
import style0 from "./OrderBinding.vue?vue&type=style&index=0&id=3ed360e7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports